import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { FC } from 'react';
import OtpInput from 'react-otp-input';

const useStyles = makeStyles(
  (theme) => ({
    input: {
      width: `${theme.spacing(4)}px !important`,
      height: theme.spacing(5),
      borderRadius: '3px',
      border: '1px solid #ACB5BD',
      '&:focus': {
        outline: 'none',
      },
    },
    focused: {
      border: '1px solid #D82662',
    },
    error: {
      border: '1px solid #DF4E2E',
    },
  }),
  { name: 'GcpOtpInput' }
);

interface GcpOtpInputProps {
  handleChange: (otp: string) => void;
  value: string;
  error: boolean;
}

const GcpOtpInput: FC<GcpOtpInputProps> = (props) => {
  const { error, handleChange, value } = props;
  const classes = useStyles();

  return (
    <OtpInput
      isInputNum
      shouldAutoFocus
      errorStyle={classes.error}
      focusStyle={classes.focused}
      hasErrored={error}
      inputStyle={classes.input}
      numInputs={6}
      separator={<span>&nbsp;&nbsp;&nbsp;</span>}
      value={value}
      onChange={handleChange}
    />
  );
};

export default GcpOtpInput;
